import Footer from "../Components/Footer";
import LeftSidebar from "../Components/LeftSidebar";
import View from "../Components/View";

import {
  resolveFilmroomPlateData,
  resolveVideoData,
  wrapFilterRequestData,
} from "../Utils/DataProcess2";
import { useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { api_getFilterResult, api_getPlayerRoster } from "../API/ballsStat";
import { MessageModal } from "../Components/Modals/MessageModal";
import Loading from "../Components/Loading";
import { resolvePlayerAutoCompleteList } from "../Utils/RosterUtils";
import { setupFilmroom } from "../Utils/filmroom";
import { Provider } from "react-redux";

import { videoStore, set_Video1_DisplayData, set_Video_idx } from "../state/videoSlice";
import "../style/css/filmroom_style.css";
import Header from "../Components/Header";

const batterNumMap = new Map(); // [name]: number
const pitcherNumMap = new Map(); // [name]: number

const Filmroom = () => {
  const multi_cam = ["gamevideo", "cam3", "cam1", "cam4", "cam8", "cam7"];
  const [modalMsg, setModalMsg] = useState("");
  const [modalVis, setModalVis] = useState(false);
  const [loading, setLoading] = useState(true);
  const [acmap, setACMap] = useState({
    BatterACOptionMap: [],
    CatcherACOptionMap: [],
    PitcherACOptionMap: [],
  });

  const [filteredData, setFilteredData] = useState([]);
  const [mode, setMode] = useState("balls");
  const [download, setDownload] = useState([]);
  const methods = useForm();

  const [videos, setVideos] = useState([]);

  useEffect(() => {
    setupFilmroom();
    const loadPreData = async () => {
      const playerInfo = await api_getPlayerRoster();
      if (playerInfo.status === "error") {
        setLoading(false);
        setModalMsg({ type: "error", msg: playerInfo.message });
        setModalVis(true);
        return false;
      } else {
        return resolvePlayerAutoCompleteList(playerInfo.data);
      }
    };
    loadPreData().then((load_data) => {
      if (!load_data) return;
      setACMap(load_data);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (!acmap) return;
    for (let i of acmap.PitcherACOptionMap) {
      if (!pitcherNumMap.has(i.label)) {
        pitcherNumMap.set(i.label, i.number);
      }
    }

    for (let i of acmap.BatterACOptionMap) {
      if (!batterNumMap.has(i.label)) {
        batterNumMap.set(i.label, i.number);
      }
    }
  }, [acmap]);

  useEffect(() => {
    if (!filteredData) return;
    setVideos(
      filteredData.map((data) =>
        resolveFilmroomPlateData(data, pitcherNumMap, batterNumMap),
      ),
    );
  }, [filteredData]);

  // @Test
  // useEffect(() => {
  //   console.log("videos: ", videos);
  // }, [videos]);

  useEffect(() => {
    if (!videos[0]) return;
    const resolveFirstData = async () => {
      setLoading(true);
      const data = await resolveVideoData(videos[0]);
      videoStore.dispatch(set_Video1_DisplayData(data));
      setLoading(false);
    };
    resolveFirstData();
  }, [videos]);

  const onSubmit = async (data) => {
    setLoading(true);
    let pdata = { ...wrapFilterRequestData(data), GameType: [1000] };
    const filterRes = await api_getFilterResult(pdata, document.cookie);
    if (filterRes.status === "error") {
      setLoading(false);
      setModalMsg({ type: "error", msg: filterRes.message });
      setModalVis(true);
    } else {
      // TODO: success operations
      if (filterRes.data.length === 0) {
        setLoading(false);
        setModalMsg({ type: "error", msg: "查無相關資料" });
        setModalVis(true);
      } else {
        filterRes.data.sort((a, b) => b.GameNo - a.GameNo);
        try {
          if (mode === "plates")
            setFilteredData(resolveFilmroomPlateData(filterRes.data));
          else setFilteredData(filterRes.data);
          setLoading(false);
          setDownload(
            new Array(filterRes.data.length * multi_cam.length).fill(false),
          );
        } catch (e) {
          console.log(e);
          setLoading(false);
          setModalMsg({ type: "error", msg: "發生問題, 請聯絡工作人員" });
          setModalVis(true);
        }
        videoStore.dispatch(set_Video_idx(0));
      }
    }
    window.scrollTo(0, 0);
  };

  return (
    <Provider store={videoStore}>
      <Header />
      <MessageModal
        type={modalMsg.type}
        message={modalMsg.msg}
        visible={modalVis}
        setVisible={setModalVis}
      />
      <Loading visible={loading} />
      <div className="wrapper">
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <FormProvider {...methods}>
            <LeftSidebar acmap={acmap} />
          </FormProvider>
        </form>
        {videos && <View videos={videos} setLoading={setLoading} />}
      </div>
      <Footer />
    </Provider>
  );
};

export default Filmroom;
